import axios from 'axios';
import { apiUrl } from '@dynapp/wc-api-generic'

export default {
  namespaced: true,
  state: {
    registrations: {}
  },
  getters: {
    items(state) {
      return state.registrations;
    }
  },
  mutations: {
    setRegistrations(state, payload) {
      state.registrations = payload;
    }
  },
  actions: {
    fetch({commit}) {
      commit('startLoading', 'barviewregistrations.read', {root: true});
      var promise = axios.get(apiUrl({
        dataObject: 'dync-appshop-web'
      }, '/barviewregistrations'));

      promise.then((res) => {
        commit('endLoading', 'barviewregistrations.read', {root: true});
        commit('setRegistrations', res.data);
      });

      promise.catch((err) => {
        commit('endLoading', 'barviewregistrations.read', {root: true});
        console.error(err);
      });

      return promise;
    }
  }
};
